export default "__VITE_ASSET__UZN92U$I__"